import { OrderMeal } from '@/models';
import { AnalyticsEvent } from '../models';

export class OrderConfirmedEvent implements AnalyticsEvent {
  bagEventType: string;
  name = 'OrderConfirmedEvent';

  constructor(event: string, public readonly meals?: OrderMeal | OrderMeal[] | null) {
    this.bagEventType = event;
  }
}
